import { render, staticRenderFns } from "./AccountSettingPassword.vue?vue&type=template&id=56280656&scoped=true"
import script from "./AccountSettingPassword.vue?vue&type=script&lang=js"
export * from "./AccountSettingPassword.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingPassword.vue?vue&type=style&index=0&id=56280656&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56280656",
  null
  
)

export default component.exports